import { render, staticRenderFns } from "./CTAbuttonOutside.vue?vue&type=template&id=56a38773&scoped=true&"
import script from "./CTAbuttonOutside.vue?vue&type=script&lang=js&"
export * from "./CTAbuttonOutside.vue?vue&type=script&lang=js&"
import style0 from "./CTAbuttonOutside.vue?vue&type=style&index=0&id=56a38773&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a38773",
  null
  
)

export default component.exports